<template>
  <div class="title is-parent is-12 is-vertical">
    <article class="tile is-child box">
      <div class="container is-child" style="margin-top:5px;">
        <div class="columns">
            <div class="column is-4">
                <p class="subtitle has-text-centered">{{Fixture.match_date}}</p>
            </div>
            <div class="column is-2">
                <img class="team_logo" :src="Fixture.home_team.logo">
                <p class="subtitle has-text-left	">{{Fixture.home_team.name}} </p>
                
            </div>
            <div class="column is-2">
                <img class="team_logo" :src="Fixture.away_team.logo">
                <p class="subtitle has-text-left">{{Fixture.away_team.name}}</p>
            </div>
            <div class="column is-4">
                <p class="subtitle has-text-centered">{{Fixture.competition}}</p>
                <p class="subtitle has-text-centered">{{Fixture.location}}</p>
            </div>
        </div>
    </div>
    </article>
</div>
</template>
<script>
export default {
  props: ['gameId'],
  data () {
    return {
      Fixture: []
    }
  },
  methods: {
    fetchFixtures () {
      this.$http.get('https://devilsapi.roblutken.com/api/games/get/single/' + this.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        console.log('Data is ' + response.data)
        this.Fixture = response.data[0]
        console.log(JSON.stringify(this.Fixture))
      }, response => {
      })
    }
  },
  mounted () {
    this.fetchFixtures()
  }
}
</script>
<style>
.team_logo{
  width: 100px;
  height:100px;
}
</style>



// WEBPACK FOOTER //
// box-score.vue?0e9d7108